import { register } from '../component.js';
import 'react';

var _socialIcons_mailto = register("mailto", {"color":"#7f7f7f","path":"M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z"});

export { _socialIcons_mailto as default };
